import { ApolloError } from '@apollo/client';
import type { GraphQLFormattedError } from 'graphql';

/**
 * Retain partial data alongside GraphQL errors without making navigation decisions.
 * Transport failures still reject the query or mutation promise.
 */
export interface DataResult<T> {
  data: T;
  error?: ApolloError;
}

export const mapResult = <T, R>(
  result: { data?: T | null; errors?: readonly GraphQLFormattedError[] },
  select: (data: T | null | undefined) => R
): DataResult<R> => ({
  data: select(result.data),
  error: result.errors?.length ? new ApolloError({ graphQLErrors: result.errors }) : undefined
});
